import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as actions from './actions';
import * as selectors from './selectors';
import { setInitialFilters } from '../filters/operations';
import * as urlQueryString from './../../urlQueryString';
import { FAILURE_ANALYSIS_PAGE_TESTS_TAB_NAME } from './constants';
import { getRootCauseDetails } from '../root-causes/operations';
import * as generalSelectors from './../general/selectors';
import { OWNER_OPTIONS_FAILURE_ANALYSIS, ROOTCAUSE_QUERY_STRINGS } from './../../constants';

import { operations } from './index';

export const getFailureTests = (isQueryStringFilter = false) => async (dispatch, getState) => {
  const testsParams = selectors.testsParamSelector(getState(), { isQueryStringFilter });
  return dispatch(actions.getFailureTests(testsParams)).catch((error) => {
    dispatch(notificationActions.notifyDanger(
      error.message, 'We\'ve experienced an issue while fetching tests.', true,
    ));
  });
};

export const fetchRootCausesForTest = ({ index, item }) => async (dispatch, getState) => {
  const params = selectors.queryParamSelector(getState(), { api: item.get('rootCauseUrl') });
  return dispatch(actions.getRootCauses({
    index, params,
  }));
};

// select initial owner only if owner exists in ownersList
export const setInitialUser = (owners) => (dispatch, getState) => {
  const [{ username }, location] = selectors.filterParamSelector(getState());
  const ownerQueryString = urlQueryString.get(location, ROOTCAUSE_QUERY_STRINGS.USER);
  if (ownerQueryString) {
    return dispatch(actions.setOwnerFromQueryString(ownerQueryString));
  }
  const ownersList = owners?.results ? owners.results : [];
  return ownersList.includes(username) ?
    dispatch(actions.setJobsOwner([username])) :
    Promise.resolve();
};

export const initJobsOwnersFilter = () => async (dispatch, getState) => {
  const user = selectors.userStore(getState());
  if (!user.isAdmin()) {
    return Promise.resolve();
  }

  return dispatch(actions.getJobOwners()).then(({ data }) => (
    dispatch(setInitialUser(data))
  ));
};

export const loadInitFilters = () => (dispatch, getState) => Promise.all([
  dispatch(initJobsOwnersFilter()),
  dispatch(setInitialFilters(
    ...generalSelectors.initialFilterSelector(
      getState(),
      selectors.defaultFilterSelector(getState()),
    ), OWNER_OPTIONS_FAILURE_ANALYSIS,
  )),
]);

export const reloadData = (selectedTab) => (dispatch) => (
  dispatch(selectedTab === FAILURE_ANALYSIS_PAGE_TESTS_TAB_NAME ?
    operations.getFailureTests() :
    getRootCauseDetails())
);
